import { StackProps } from './Stack';
import { Theme, css } from '@emotion/react';

const SpacingMap = {
  sm: 1,
  md: 3,
  lg: 5,
};

const DirectionalPropsMap: {
  [key: string]: { flow: 'row' | 'column'; gapSide: 'bottom' | 'right' };
} = {
  vertical: {
    flow: 'row',
    gapSide: 'bottom',
  },
  horizontal: {
    flow: 'column',
    gapSide: 'right',
  },
};

const returnSpaceByType = (spacing: StackProps['spacing']) => {
  if (spacing) {
    if (typeof spacing === 'string') {
      return SpacingMap[spacing];
    }
    if (typeof spacing === 'number') {
      return spacing;
    }
  }
  return 0;
};

export const stackStyles = (
  { spacing: spacingVars, colors }: Theme,
  direction: StackProps['direction'],
  spacing: StackProps['spacing'],
  divider: StackProps['divider'],
  inline: StackProps['inline'],
  alignItems: StackProps['alignItems']
) => {
  const setSpace = returnSpaceByType(spacing);
  const directionWithDefault = direction || 'vertical';
  const flow = DirectionalPropsMap[directionWithDefault].flow;
  const gapSide = DirectionalPropsMap[directionWithDefault].gapSide;

  return css`
    display: ${inline ? 'inline-grid' : 'grid'};
    grid-auto-flow: ${flow};
    grid-auto-${flow}s: auto;
    grid-template-${flow}s: auto;
    gap: ${spacingVars(setSpace)}px;
    align-items: ${alignItems};
    & > div:not(:last-child) {
      border-${gapSide}: ${divider ? 1 : 0}px solid ${colors.borderDefault};
      padding-${gapSide}: ${divider ? spacingVars(setSpace) : 0}px;
    }
  `;
};
